import { AbstractControl, ValidatorFn } from '@angular/forms';
import { IDateRange } from '../components/ui-elements/date-picker/models/date-range';
import { ErrorMessage } from '../constants/error-message.constants';

export function dateValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!(control.value instanceof Date)) {
        return {
            date: { message: ErrorMessage.date }
        };
    }

    return null;
}

export function minDateValidator(date: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } =>
        control.value < date ? { minDate: { value: control.value } } : null;
}

export function noFutureDateValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value === '' || control.value === null) {
        return null;
    } else if (control.value > new Date()) {
        return {
            noFutureDate: { message: ErrorMessage.pastDate }
        };
    }

    return null;
}

export function noPastDateValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value === '' || control.value === null) {
        return null;
    } else if (control.value < new Date()) {
        return {
            noPastDate: { message: ErrorMessage.futureDate }
        };
    }

    return null;
}

export function maxDateValidator(date: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } =>
        control.value > date ? { maxDate: { value: control.value } } : null;
}

export function minDateRangeValidator(_date: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const validationObj = { minDateRange: {} };
        return Object.keys(control.value as IDateRange).reduce(
            (acc: { [key: string]: any }, key) => {
                const date = control.value[key];
                if (date < _date) {
                    if (acc == null) {
                        acc = validationObj;
                    }
                    acc.minDateRange[key] = { value: date };
                }
                return acc;
            },
            null
        );
    };
}

export function maxDateRangeValidator(_date: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const validationObj = { maxDateRange: {} };
        return Object.keys(control.value as IDateRange).reduce(
            (acc: { [key: string]: any }, key) => {
                const date = control.value[key];
                if (date > _date) {
                    if (acc == null) {
                        acc = validationObj;
                    }
                    acc.maxDateRange[key] = { value: date };
                }
                return acc;
            },
            null
        );
    };
}

export function dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {
    if (
        control.value &&
        (!(control.value.end instanceof Date) ||
            !control.value.end ||
            !(control.value.start instanceof Date) ||
            !control.value.start)
    ) {
        return {
            dateRange: { message: ErrorMessage.required }
        };
    }
    return null;
}
